// extracted by mini-css-extract-plugin
export default {"image":"FlcqxrBY","link":"AqfuWw8f","mobile":"mobile","icon":"s6KfyUOL","social":"R30HzUoy","time":"mI_RYBIC","rubric":"E7gT1R7M","button":"xfutOWOm"};